import React, { useContext, useState } from 'react';
import { Backdrop, Box, Button, Paper, Stack, TextField } from '@mui/material';

import useErrorHandler from '../utils/error-handler';
import { AuthStoreContext } from './Root';
import FullLogo from './images/FullLogo';

const USER_REG = /^[a-zA-Z0-9]*$/;

export default function Login() {
    const { authStore } = useContext(AuthStoreContext);
    const errorHandler = useErrorHandler();

    const [login, setLogin] = useState('');
    const [loginError, setLoginError] = useState(false);
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(false);

    function onLoginChange(event: React.ChangeEvent<HTMLInputElement>) {
        const accept = USER_REG.test(event.target.value);
        if (accept) setLogin(event.target.value);
        if (loginError !== !accept) setLoginError(!accept);
    }

    function onPasswordChange(event: React.ChangeEvent<HTMLInputElement>) {
        const err = !event.target.value.length;
        if (err !== passwordError) setPasswordError(err);
        setPassword(event.target.value);
    }

    function onPressed(event: React.KeyboardEvent) {
        if (event.key === 'Enter') onApplyButtonClick();
    }

    async function onApplyButtonClick() {
        try {
            if (login.length === 0) {
                setLoginError(true);
                throw new Error('Поле "Логин" не может быть пустым');
            }
            if (password.length === 0) {
                setPasswordError(true);
                throw new Error('Поле "Пароль не может быть пустым');
            }
            if (password.length < 5) {
                setPasswordError(true);
                throw new Error('Не верные данные');
            }
            await authStore.login(login, password);
        } catch (e) {
            errorHandler(e);
        }
    }

    return (
        <Backdrop sx={{ backgroundColor: '#ffffff' }} open>
            <Paper
                elevation={5}
                sx={{
                    padding: '10px 40px',
                    borderRadius: '20px' /*, boxShadow: '2px 4px 14px rgba(13, 32, 103, 0.9)'*/,
                }}
            >
                <Stack margin={2}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <FullLogo sx={{ fontSize: '100px', height: '50%' }} />
                    </Box>
                    <TextField
                        label="Логин"
                        variant="outlined"
                        margin="normal"
                        value={login}
                        error={loginError}
                        onChange={onLoginChange}
                        onKeyDown={onPressed}
                    />
                    <TextField
                        label="Пароль"
                        variant="outlined"
                        type="password"
                        margin="normal"
                        value={password}
                        error={passwordError}
                        onChange={onPasswordChange}
                        onKeyDown={onPressed}
                    />
                    <Box sx={{ padding: '1em 0', display: 'flex', justifyContent: 'end' }}>
                        <Button variant="contained" color="primary" onClick={onApplyButtonClick}>
                            Вход
                        </Button>
                    </Box>
                </Stack>
            </Paper>
        </Backdrop>
    );
}
